import { Button, Col, Form, Modal, Row, Select, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch, questionServiceQuestionBrandModalSliceDispatch } from "../../Constants/ReduxConstants";

function QuestionServiceQuestionBrandModal() {
    const open = useSelector((state: any) => state.questionServiceQuestionBrandModal.open);

    // Data
    const currentQuestion = useSelector((state: any) => state.questionViewer.currentQuestion);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const pendingServiceBrandQuestions = useSelector((state: any) => state.questionServiceQuestionBrandModal.pendingServiceBrandQuestions);

    // Options
    const allBrands = useSelector((state: any) => state.pickAFile.brandList);
    const allServices = useSelector((state: any) => state.pickAFile.serviceList);
    const servicesDropDown = allServices.map(s => { return ({ key: s.serviceId, label: s.serviceName, value: s.serviceId }) }) ?? [];
    const brandDownDrop = allBrands.map(b => { return ({ key: b.brandId, label: b.brandName, value: b.brandId }) }) ?? [];
    const selectedBrand = useSelector((state: any) => state.questionServiceQuestionBrandModal.selectedBrand);
    const selectedService = useSelector((state: any) => state.questionServiceQuestionBrandModal.selectedService);

    // Add state button
    const invalid = !selectedBrand || !selectedService;
    const alreadyExists = pendingServiceBrandQuestions.some(q => q.brandId === selectedBrand && q.assistanceServiceId === selectedService);

    const dispatch = useDispatch();

    const onOptionDelete = (deletingOption) => {
        const updated = pendingServiceBrandQuestions.filter(b => b.brandId !== deletingOption.brandId || b.assistanceServiceId !== deletingOption.assistanceServiceId);

        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions, payload: updated });
    }

    const onOptionAdd = () => {
        const updated = [...pendingServiceBrandQuestions, { assistanceServiceId: selectedService, brandId: selectedBrand, questionId: currentQuestion.questionId }];
        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions, payload: updated });
    }

    const getServiceDisplay = (serviceId) => {
        return allServices.filter(s => s.serviceId === serviceId)[0]?.serviceName;
    }

    const getBrandDisplay = (brandId) => {
        return allBrands.filter(b => b.brandId === brandId)[0]?.brandName;
    }

    const onCancel = () => {
        dispatch({
            type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions,
            payload: currentServiceQuestionBrand.filter(s => s.questionId === currentQuestion.questionId)
        });
        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setOpen, payload: false });
    }

    const onSubmit = () => {
        let filteredServiceQuestions = currentServiceQuestionBrand.filter(q => q.questionId !== currentQuestion.questionId);
        dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: [...filteredServiceQuestions, ...pendingServiceBrandQuestions] });
        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setOpen, payload: false });
    }

    let columns = [
        {
            title: 'Service',
            dataIndex: 'Service',
            key: 'Service',
            render: (text) => <p>{text}</p>
        },
        {
            title: 'Brand',
            dataIndex: 'Brand',
            key: 'Brand',
            render: (text) => <p>{text}</p>
        },
        {
            title: 'Delete',
            dataIndex: 'Delete',
            key: 'Delete',
            render: (text) => <Button data-delete={text} onClick={() => onOptionDelete(text)}>Delete</Button>
        }
    ]

    let data = pendingServiceBrandQuestions.map((serviceBrandQuestion, serviceBrandQuestionIndex) => {
        return {
            Service: allServices.filter(x => x.serviceId == serviceBrandQuestion.assistanceServiceId).map(y => y.serviceName),
            Brand: allBrands.filter(x => x.brandId == serviceBrandQuestion.brandId).map(y => y.brandName),
            key: serviceBrandQuestionIndex,
            Delete: serviceBrandQuestion
        }
    })

    const getTableRows = <Table columns={columns} dataSource={data} pagination={false} />

    const selectedBrandChanged = (value) => {
        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setSelectedBrand, payload: value });
    }

    const selectedServiceChanged = (value) => {
        dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setSelectedService, payload: value });
    }

    return open ? (
        <Modal
            title="Options"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
        >
            <Form
                onFinish={onSubmit}
                onFinishFailed={onCancel}
                preserve={false}
            >
                <Row>
                    <Col>
                        <Select
                            placeholder='Select Service'
                            allowClear
                            options={servicesDropDown}
                            onChange={selectedServiceChanged}
                            id="service"
                        />
                    </Col>
                    <Col>
                        <Select
                            placeholder='Select Brand'
                            allowClear
                            options={brandDownDrop}
                            onChange={selectedBrandChanged}
                            id="brand"
                        />
                    </Col>
                    <Col>
                        <Button disabled={invalid || alreadyExists} onClick={onOptionAdd}>Add Brand</Button>
                    </Col>
                </Row>
                <div style={{ overflow: 'auto' }}>
                    {getTableRows}
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    ) : (
        <Button onClick={() => {
            dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setOpen, payload: true });
        }}>Edit Brands</Button>
    )
}

export default QuestionServiceQuestionBrandModal;